module.exports = __webpack_public_path__ + "img/withdraw-suc-icon.c01ebb6d.png";